export const MANAGEMENT_PLATFORM_PATHS = {
    root: 'management-platform',
    dashboard: 'management-platform/:contextOrgId',
    details: 'management-platform/:contextOrgId/details',
    organization: 'management-platform/:contextOrgId/organization/:organizationId',
    organizationClients: 'management-platform/:contextOrgId/organization/:organizationId/clients',
    organizationCreateContract: 'management-platform/:contextOrgId/organization/:organizationId/create-contract',
    organizationPreviewContract: 'management-platform/:contextOrgId/organization/:organizationId/preview-contract',
    organizationPrepareUpgrade: 'management-platform/:contextOrgId/organization/:organizationId/prepare-upgrade',
    organizationSetupFilespaceUpgrade: 'management-platform/:contextOrgId/organization/:organizationId/setup-filespace-upgrade',
    organizationViewFilespaceUpgrade: 'management-platform/:contextOrgId/organization/:organizationId/view-filespace-upgrade',
    organizationMigrateContract: 'management-platform/:contextOrgId/organization/:organizationId/migrate-contract',
    organizationUpsell: 'management-platform/:contextOrgId/organization/:organizationId/upsell',
};
